<template>
	<v-layout 
		align-center 
		justify-center
		fill-height
	>
		<v-flex
			xs8
		>
			<v-card
				dark
				color="#00001B"
				flat
				elevation="20"
				mb-3
			>
				<v-layout 
					row
					class="sign-in-container"
					align-center
				>
					<v-btn
						flat
						color="white"
						@click="showSignUpForm (false)"
					>
						<v-icon
							left				
							size="16"
						>
							fas fa-arrow-left
						</v-icon>
						Log-in
					</v-btn>
				</v-layout>

				<v-stepper v-model="stepperCount">
					<v-stepper-header
						class="stepper-header-container"
					>
						<v-stepper-step 
							:complete="stepperCount > 1" 
							class="stepper-value"
							step="1"
							complete-icon="fas fa-check-circle primary"
						>
							Security
						</v-stepper-step>
						<v-stepper-step 
							:complete="stepperCount > 2" 
							step="2"
							complete-icon="fas fa-check-circle"
						>
							Info
						</v-stepper-step>
						<v-stepper-step 
							:complete="stepperCount > 3" 
							step="3"
							complete-icon="fas fa-check-circle"
						>
							Info-Wallet
						</v-stepper-step>
						<v-stepper-step 
							:complete="stepperCount > 4" 
							step="4"
							complete-icon="fas fa-check-circle"
						>
							Identity
						</v-stepper-step>
					</v-stepper-header>
		

					<v-container 
						class="stepper-container"
						grid-list-xl 
						text-xs-center
					>
						<v-stepper-content step="1">
							<mail-and-password 
								:credentials="credentials"
							/>
						</v-stepper-content>

						<v-stepper-content step="2">
							<personal-information 
								:credentials="credentials"
							/>
						</v-stepper-content>

						<v-stepper-content step="3">
							<info-wallet 
								:default-account="metamaskAccount"
								:metamask-installed="metamaskInstalled"
								@clickReloadStatus="loadWallet"
							/>
						</v-stepper-content>

						<v-stepper-content step="4">
							<identity 
								:credentials="credentials"
							/>
						</v-stepper-content>
					</v-container>
				</v-stepper>
				<v-divider />
								
				<v-card-actions>
					<v-btn 
						v-if="stepperCount != 1"
						flat
						color="error" 
						@click="stepperCount = stepperCount - 1"
					>
						Back
					</v-btn>
					<v-btn 
						v-if="stepperCount == 1"
						flat
						color="error" 
						@click="dismissAuthentication ()"
					>
						Dismiss
					</v-btn>
					<v-spacer />
					<v-btn 
						v-if="stepperCount != 4"
						flat
						:disabled="!valid || (stepperCount == 3 && !metamaskInstalled)" 
						color="success"
						@click="stepperCount += 1"
					>
						Next
					</v-btn>
					<v-btn 
						v-if="stepperCount == 1 || (stepperCount == 4 && metamaskInstalled)"
						flat
						:disabled="!valid" 
						color="success"
						@click="submitDidSelect()"
					>
						Submit
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapMutations, 
	mapActions, 
	mapGetters, 
	mapState } from 'vuex'

export default {
	data () {
		return {
			stepperCount: 1,
			alertLabel: '',
			credentials: {
				email: '',
				password: '',
				name: '',
				surname: '',
				phone: '',
				birth: null,
				address: '',
				country: '',
				userPhoto: '',
				userDocument: null,
				userInvoice: null
			}
		}
	},

	computed: {

		...mapState ({
			user: state => state.auth.user,
			metamaskAccount: state => state.wallet.defaultAccount,
			metamaskInstalled: state => state.wallet.metamaskInstalled
		}),

		progress () {
			return Math.min (100, this.value.length * 10)
		},

		color () {
			return ['error', 'warning', 'success'][Math.floor (this.progress / 40)]
		},

		valid () {
			const {email, password, name, surname, phone, birth, address, country } = this.credentials

			switch (this.stepperCount) {
			case 1:
				if (email != '', password != '') {
					return true
				} else {
					return false
				}
			case 2:
				if (name != '', surname != '', phone != '', birth != null, address != '', country != '') {
					return true
				} else {
					return false
				}
			case 3:
				if (this.metamaskAccount) {
					return true
				} else {
					return false
				}
			case 4: 
				return true
				if (this.credentials.userPhoto && this.credentials.userInvoice && this.credentials.userDocument) {
					return true
				} else {
					return false
				}
			default:
				return false
			}
		}
	},

	watch: {
		'user': function (user) {
			if (!user)
				return
			console.log ('Login ok with:', user.displayName)
			this.$router.push ({ path: '/' })
		},
	},

	created () {
		this.loadWallet ()
	},

	methods: {
		...mapMutations (['showSignUpForm','dismissAuthentication', 'SHOW_ALERT']),
		...mapActions (['createUser', 'loadWallet', 'createUserWithEmailAndPassword']),

		submitDidSelect () {
			console.log(this.stepperCount)
			if (this.stepperCount == 1) {
				this.submitMailAndPassword()
			} else if (this.stepperCount == 4) {
				this.showAlertInWallet()
			}
		},

		submitMailAndPassword () {
			console.log ("Mammt")
			this.SHOW_ALERT ({
				text: 'Attention',
				message: 'If you proceed now you will not be able to buy RE20. To confirm your identity, continue with others info in the next steps.',
				dismissable: true,
				actions: [{
					text: 'Confirm',
					handler: () => {
						this.createUserWithEmailAndPassword({...this.credentials, defaultAccount: this.metamaskAccount})
					},
					type: 'success'
				}]
			})		
			
		},
		
		showAlertInWallet () {
			if (this.credentials.userPhoto && this.credentials.userInvoice && this.credentials.userDocument) {
				this.SHOW_ALERT ({
					text: 'End of the registration',
					message: '',
					dismissable: false,
					actions: [{
						text: 'Back to login',
						handler: () => {
							this.createUser ({...this.credentials, defaultAccount: this.metamaskAccount})
						},
						type: 'success'
					}]
				})
			} else {
				this.SHOW_ALERT ({
					text: 'Identity not confirmed',
					message: 'If you proceed now you will not be able to buy RE20. To confirm your identity, close this dialog and click on the next button.',
					dismissable: true,
					actions: [{
						text: 'Confirm',
						handler: () => {
							this.createUser ({...this.credentials, defaultAccount: this.metamaskAccount})
						},
						type: 'success'
					}]
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: $primary;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
}

.sign-button:hover {
	text-decoration: underline;
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

.back-text {
	color: $primary;
	font-weight: 500;
	font-size: 16px;
}

.stepper-container {
	background-color: #00001B;
}

.stepper-header-container {
	border-top: 1px solid white;
	border-bottom: 1px solid white;
	background-color: #00001B;
}

.v-stepper__step__step .white {
	color: red !important;
}
</style>
